import React from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AddItem from "../Carrito/AddItem";
import { useContext } from 'react';
import { authContext } from '../Context/AuthContext';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import sinimagen from './sinimagen.gif';
import "./TablesCategorias.css"

function TablesCategorias({ articulosPorCategoria = [], isMobile = false }) {
    const pais = process.env.REACT_APP_COUNTRY || 'ARG';
    const navigate = useNavigate();
    const { token } = useContext(authContext);
    const [t] = useTranslation("global");

    const formatNumber = (number) => {
        if (number === undefined || number === null) return '0,00';
        
        const num = typeof number === 'number' ? number : parseFloat(number);
        return isNaN(num) ? '0,00' : 
            new Intl.NumberFormat('es-AR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(num);
    };

    const getImageSrc = (imagenes) => {
        try {
            if (!imagenes) return process.env.PUBLIC_URL + '/articulos/thumbs/default.jpg';
            const firstImage = imagenes.split(',')[0].trim();
            return process.env.PUBLIC_URL + `/articulos/thumbs/${encodeURIComponent(firstImage)}`;
        } catch (e) {
            console.error('Error procesando imagen:', e);
            return process.env.PUBLIC_URL + '/articulos/thumbs/default.jpg';
        }
    };

    const renderProductLink = (articulo) => {
        const linkProps = {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.25rem 0.5rem',
                fontSize: '0.75rem',
                justifyContent: 'center',
                minWidth: '120px',
                textDecoration: 'none',
                color: '#dc3545',
                border: '1px solid #dc3545',
                borderRadius: '0.25rem',
                backgroundColor: 'transparent',
                transition: 'background-color 0.2s, color 0.2s',
            },
            to: `/detalle?sku=${articulo.Alias || ''}`,
            onClick: (event) => {
                if (event.button === 1) {
                    window.open(`/detalle?sku=${articulo.Alias || ''}`, "_blank");
                    event.preventDefault();
                }
            },
            onMouseEnter: (e) => {
                e.currentTarget.style.backgroundColor = '#dc3545';
                e.currentTarget.style.color = 'white';
            },
            onMouseLeave: (e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#dc3545';
            }
        };

        return (
            <Link {...linkProps}>
                {t("producto.ver-producto")}
            </Link>
        );
    };

    const renderAddItem = (articulo) => {
        if (articulo.Precio === undefined || articulo.Precio === null) return null;
        
        return (
            <div className="btnTables">
                <AddItem producto={articulo} />
            </div>
        );
    };

    const renderStockInfo = (articulo) => {
        if (articulo?.Stock <= 0 || articulo?.Precio === undefined) return null;
        
        return (
            <>
                Stock: {articulo.Stock || 0}
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                {articulo?.Moneda_Signo && `Valor: ${articulo.Moneda_Signo} ${formatNumber(articulo.Precio)}`}
            </>
        );
    };

    const renderPriceNote = () => {
        if (pais === "PA") {
            return '*no incluyen ITBMS';
        } else if (pais !== "USA") {
            return '*no incluye IVA';
        }
        return null;
    };

    if (!Array.isArray(articulosPorCategoria) || articulosPorCategoria.length === 0) {
        return (
            <div className="text-center py-4">
                <p>No hay mas artículos disponibles</p>
            </div>
        );
    }

    return (
        <div className="table-container">
            <Table hover responsive={isMobile} variant='light'>
                <tbody className="editTabla">
                    {articulosPorCategoria.map((articulo, idx) => (
                        <tr key={`${articulo.Alias || idx}-${idx}`}>
                            <td>
                            <h6
                                className="table-name-product hover-imagen"
                                onClick={() => navigate(`/detalle?sku=${articulo.Alias}`)}
                            >
                                {articulo.Nombre || 'Nombre no disponible'}
                                <span className="mini-image-tooltip">
                                <img
                                    src={
                                    articulo.Imagenes
                                        ? process.env.PUBLIC_URL + `/articulos/thumbs/${encodeURIComponent(String(articulo.Imagenes.split(',')[0]))}`
                                        : sinimagen
                                    }
                                    alt="vista previa"
                                />
                                </span>
                            </h6>
                                    <div className="articulo-info-linea">
                                        <p className="numero-de-parte">
                                            Marca: {articulo.Marca || 'N/A'}
                                        </p>

                                        <p className="numero-de-parte">
                                            SKU: {articulo.Alias || 'N/A'}
                                        </p>

                                        <p className="numero-de-parte">
                                            {renderStockInfo(articulo)}
                                        </p>

                                        {articulo.Precio !== undefined && (
                                            <p className='precios-sin-iva-card'>
                                                {renderPriceNote()}
                                            </p>
                                        )}
                                    </div>
                            </td>
                            <td className="table-botonera">
                                <div className="button-container">
                                    <div className="button-contenedor-principal">
                                        <div className="logged-buttons-categorias">
                                            <div className="ver-producto-container">
                                                {!token ? (
                                                    renderProductLink(articulo)
                                                ) : (
                                                    <div className='d-flex justify-content-evenly gap-3'>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            {renderProductLink(articulo)}
                                                        </div>
                                                        {renderAddItem(articulo)}
                                                    </div>
                                                )}
                                                        {/* <div>
                                                            {renderProductLink(articulo)}
                                                        </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}

TablesCategorias.propTypes = {
    articulosPorCategoria: PropTypes.arrayOf(
        PropTypes.shape({
            Alias: PropTypes.string,
            Nombre: PropTypes.string,
            Marca: PropTypes.string,
            Imagenes: PropTypes.string,
            Stock: PropTypes.number,
            Precio: PropTypes.number,
            Moneda_Signo: PropTypes.string
        })
    ),
    isMobile: PropTypes.bool
};

TablesCategorias.defaultProps = {
    articulosPorCategoria: [],
    isMobile: false
};

export default React.memo(TablesCategorias);